var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from 'react';
import { AntdSchemaFieldAdaptor, pickFormItemProps, pickNotFormItemProps } from '@formily/antd';
import { createVirtualBox } from '@formily/react-schema-renderer';
import { toArr } from '@formily/shared';
import { Row, Col } from 'antd';
import { normalizeCol } from '../shared';
export var FormItemGrid = createVirtualBox('grid', function (props) {
    var rawCols = props.cols, title = props.title, label = props.label;
    var formItemProps = pickFormItemProps(props);
    var gridProps = pickNotFormItemProps(props);
    var children = toArr(props.children);
    var cols = toArr(rawCols).map(function (col) { return normalizeCol(col); });
    var childNum = children.length;
    if (cols.length < childNum) {
        var offset = childNum - cols.length;
        var lastSpan = 24 -
            cols.reduce(function (buf, col) {
                return (buf +
                    Number(col.span ? col.span : 0) +
                    Number(col.offset ? col.offset : 0));
            }, 0);
        for (var i = 0; i < offset; i++) {
            cols.push({ span: Math.floor(lastSpan / offset) });
        }
    }
    var grids = (React.createElement(Row, __assign({}, gridProps), children.reduce(function (buf, child, key) {
        return child
            ? buf.concat(React.createElement(Col, __assign({ key: key }, cols[key]), child))
            : buf;
    }, [])));
    if (title || label) {
        return (React.createElement(AntdSchemaFieldAdaptor, __assign({}, formItemProps), grids));
    }
    return React.createElement(Fragment, null, grids);
});
export default FormItemGrid;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/form-item-grid/index.js
// module id = 6615
// module chunks = 0